// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-card__controls{display:flex}.product-card__control-button{width:100%}", ""]);
// Exports
module.exports = exports;
